import { doGet } from '../http/httpHelper';

export const getSales = async (cpf, page, pageSize, startDate, endDate) => {
    let url = `/sales?`;
    const params = [];
    if (cpf && cpf !== '') {
        params.push('cpf=' + cpf);
    }
    if (startDate && startDate !== '') {
        params.push('startDate=' + startDate);
    }
    if (endDate && endDate !== '') {
        params.push('endDate=' + endDate);
    }
    if (page && page !== '') {
        params.push('page=' + page);
    }
    if (pageSize && pageSize !== '') {
        params.push('pageSize=' + pageSize);
    }
    url = url + params.join('&');
    const resp = await doGet(url);
    return resp;
};

export const getLastSales = async (cpf, cnpj, page, pageSize, startDate, endDate) => {
    let url = `/lastSales?`;
    const params = [];
    if (cpf && cpf !== '') {
        params.push('cpf=' + cpf);
    }
    if (cnpj && cnpj !== '') {
        params.push('cnpj=' + cnpj);
    }
    if (startDate && startDate !== '') {
        params.push('startDate=' + startDate);
    }
    if (endDate && endDate !== '') {
        params.push('endDate=' + endDate);
    }
    if (page && page !== '') {
        params.push('page=' + page);
    }
    if (pageSize && pageSize !== '') {
        params.push('pageSize=' + pageSize);
    }
    url = url + params.join('&');
    const resp = await doGet(url);
    return resp;
};

export const getSapSales = async (sap, page, pageSize, product, startDate, endDate) => {
    let url = `/sapSales?`;
    const params = [];
    if (sap && sap !== '') {
        params.push('sap=' + sap);
    }
    if (product && product !== '') {
        params.push('product=' + product);
    }
    if (startDate && startDate !== '') {
        params.push('initialDate=' + startDate);
    }
    if (endDate && endDate !== '') {
        params.push('finalDate=' + endDate);
    }
    if (page !== undefined && page !== null && page !== '') {
        params.push('page=' + page);
    }
    if (pageSize !== undefined && pageSize !== null && pageSize !== '') {
        params.push('pageSize=' + pageSize);
    }
    url = url + params.join('&');
    const resp = await doGet(url);
    return resp;
};
